exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ConfirmModal-module__wrapper___AoDrZ{display:grid;gap:1rem}.ConfirmModal-module__wrapper___AoDrZ img{width:200px;margin:0 auto}.ConfirmModal-module__wrapper___AoDrZ strong{display:block}.ConfirmModal-module__wrapper___AoDrZ .ConfirmModal-module__button-wrapper___12YXp{display:grid;gap:1rem;grid-auto-flow:column;justify-content:end}", ""]);

// exports
exports.locals = {
	"wrapper": "ConfirmModal-module__wrapper___AoDrZ",
	"button-wrapper": "ConfirmModal-module__button-wrapper___12YXp"
};